<header class="tax-app-header">
  <div class="content wrapper-content">

    <!--#region Left side-->
    <div class="tax-app-header__content ">
      <picture>
        <source media="(width < 800px)" srcset="assets/img/icons-principal/logo-header-main-responsive.png">
        <source media="(width >= 800px)" srcset="assets/img/icons-principal/logo-header-main.png">
        <img class=" logo_main_header" src="assets/img/icons-principal/logo-header-main.png"
             draggable="false" alt="Portal de Tramites Gobernacion del Magdalena"/>
      </picture>

    </div>
    <!--#endregion Left side-->
    <!--#region Right side-->
    <div class="tax-app-header__content justify-content-end">
      <picture >
        <source media="(width >= 800px)" srcset="assets/img/icons-principal/logo-tramitfly.png"/>
        <source media="(800px > width >= 730px)" srcset="assets/img/icons-principal/logo-tramitfly-responsive.png" />
        <source media="(729px >= width > 500px)"  srcset="assets/img/icons-principal/ico-normal-tramitfly-2x.png"  />
        <source media="( 499px >= width )"  srcset="assets/img/icons-principal/ico-normal-tramitfly.png" />
        <img src="assets/img/icons-principal/logo-tramitfly.png" draggable="false"  class="logo_app" alt="Logo TramitFly" />
      </picture>


      <!--#endregion Mobile Menu-->
      <div class="ml-4 flex gap-1 header-actions-button">
        <button pButton class="p-button-text p-button-icon-only p-button-rounded" (click)="openOverlay(op, menuTemplate, $event)">
          <i class="pi pi-bars" ></i>
        </button>
        <a  *ngIf="isLoggedIn" (click)="openOverlay(op, profileTemplate, $event)"
            class="cursor-pointer profile-wrapper md:flex hidden">
          <p-avatar [label]="shortName"
                    size="large"
                    [style]="{width: '2.5rem', height: '2.5rem', background:'#0077CC', color: 'white'}"
                    shape="circle">
          </p-avatar>
        </a>

      </div>
    </div>
  </div>


  <!--#endregion Left side-->
</header>

<ng-template #menuTemplate>
  <ul class="tax-app-menu__ul tx-ul-menu-mobile  py-0 flex-column " (click)="showMenuMobile = false;">
    <li class="tax-app-menu__li sm:hidden flex bg-gray-100 mb-3 border-round-lg p-3 " *ngIf="isLoggedIn" >
      <ng-container *ngTemplateOutlet="profileTemplate"></ng-container>
    </li>
    <ng-container *ngFor="let item of menuItems; let i = index">
      <li *ngIf="item.visible" class="tax-app-menu__li" [routerLink]="item.routerLink"
          [class.separator-item]="item?.separator" [attr.role]="item?.separator ? 'separator' : 'menuitem'"
          (click)="item.command ? item.command({ originalEvent: $event, item: item }) : null">
        @if (!item.separator) {
          <div class="flex px-3 content-item-menu text-blue-general" [ngClass]="item.styleClass">
            <div>
              <i [class]=" item.icon + ' tax-app-menu__icon Inline pl-0'"></i>
            </div>
            <div class="tax-menu-sub-opcion--mobile ml-3 text-menu">
              <p class="my-0">{{ item.label }}</p>
            </div>
          </div>
        }
      </li>
    </ng-container>
  </ul>
</ng-template>

<p-overlayPanel #op>
  <ng-template pTemplate="content" >
    <div style="width:270px;">
      <ng-container [ngTemplateOutlet]="dynamicTemplate"></ng-container>
    </div>
  </ng-template>
</p-overlayPanel>

<ng-template #profileTemplate>
  <div class="topbar-item profile-item active-topmenuitem">
    <ul class="profile-item-submenu fadeInDown list-none pl-0">
      <li class="profile-submenu-header cursor-auto  " style=" display: flex; justify-content: center;">
        <div class="profile flex align-items-center flex flex-column gap-2">
          <p-avatar [label]="shortName"
                    [style]="{'background-color': '#0A4360', 'color': '#ffffff'}"
                    size="large" shape="circle"></p-avatar>
          <span class="font-normal font-16 color-blue-2">{{userName}}</span>
        </div>
      </li>
      <li class="separator-item" role="separator"></li>
      <li>
        <button pButton type="button" (click)="verPerfil()"  iconPos="right" icon="pi pi-user"  [label]="verPerfilLabel"
                class="bg-button-outline-blue-light border-outline-blue-light
         font-normal  text-blue-general w-full" > </button>
      </li>
    </ul>
  </div>
</ng-template>
